<form>
  <div class="qualificates-theme" style="display: block;">
    <div fxLayout="column">

      <div fxFlex="100" fxLayout="column">
        <div fxFlex="100" fxLayout="row" class="table-title">
          <div fxFlex="100">
            <div fxFlex="3" class="number-title">
              <span>{{data.data.position}}</span>
            </div>
            <div fxFlex="97" class="title-essay-dialog">
              <mat-form-field class="campoFormulario">
                <input class="input-title-essay" matInput name="title-essay"
                  [(ngModel)]="data.data.testDescription">
              </mat-form-field>
            </div>
          </div>
        </div>

        @if (showTestEssay()) {
          <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
            <div fxFlex="100">
              <div fxFlex="100" class="center-text">
                <span> {{ 'executionEdit.instrumentationUse.title' | translate }}</span>
              </div>
              <div fxFlex="10" style="text-align: end;" align="end">
                <button mat-icon-button class="btn-add without-border" (click)="openCreateDialogInstrumentalUsed()"
                  color="accent">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }


        @if (showTestEssay()) {
          <div
            fxFlex="100" fxLayout="column" class="container-verification-data">
            <div fxFlex="100" fxLayout="column">
              <table mat-table #protocolQTestInstrumentalUsedT
                [dataSource]="dataSource.protocolQTestInstrumentalUsed" style="width: 100%;">
                <ng-container matColumnDef="instrumental">
                  <th mat-header-cell *matHeaderCellDef> {{
                    'executionEdit.test.instrumental.cols.instrumental' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item">{{ item.translation ? ('instrumentation.' +
                  item.translation | translate) : '' }}</td>
                </ng-container>
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.edit' |
                    translate }}
                  </th>
                  <td mat-cell *matCellDef="let item; let indexInstrumental = index">
                    <button mat-icon-button
                      (click)="openEditDialogInstrumentalUsed(indexInstrumental, item)"
                      matTooltip="{{ 'button.edit' | translate }}">
                      <mat-icon>mode_edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <!-- Delete Column -->
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef> {{ 'executionEdit.test.observations.cols.delete'
                    | translate }}
                  </th>
                  <td mat-cell *matCellDef="let item; let indexInstrumental = index">
                    <button mat-icon-button (click)="deleteInstrumentalUsed(indexInstrumental)"
                      matTooltip="{{ 'button.delete' | translate }}">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColsInstrumentalUsed"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColsInstrumentalUsed;"></tr>
              </table>
            </div>
          </div>
        }


        @if (showTestEssay()) {
          <div fxLayout="row" class="table-item title-table-test">
            <div fxFlex="100">
              <div fxFlex="95" class="center-text">
                <span> {{ 'protocolEdit.essays.title.generic' | translate }}</span>
              </div>
              <div fxFlex="5">
                <button mat-icon-button class="btn-add without-border" (click)="newEssayOpenDialog()"
                  [disabled]="!showButton()">
                  <mat-icon fxHide.lt-sm>add</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }
        @if (dataSource.protocolQTestEssayGroup?.length > 0) {
          <div fxFlex="100" fxLayout="column" class="container-verification-data"
            >
            <table mat-table [dataSource]="dataSource.protocolQTestEssayGroup" style="min-width: 95%"
              cdkDropListData="dataSource.protocolQTestEssayGroup" [cdkDropListDisabled]="dragDisabled"
              cdkDropList class="verification-drop-list" (cdkDropListDropped)="dropEssay($event)"
              #essaysTable>
              <ng-container matColumnDef="order" sticky>
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="dragCursor" (mousedown)="dragDisabled = false;">reorder</mat-icon>
                </td>
              </ng-container>
              <!-- Type Column -->
              <ng-container matColumnDef="essayType">
                <th mat-header-cell *matHeaderCellDef> {{ 'protocolEdit.essays.essay.label' | translate }}
                </th>
                <td mat-cell *matCellDef="let element"> {{ ('essayType.' + element.translationType |
                translate) + (element.title ? " ("+element.title+")": "") }} </td>
              </ng-container>
              <!-- Variables Column -->
              <ng-container matColumnDef="variables">
                <th mat-header-cell *matHeaderCellDef> {{ 'protocolEdit.essays.variables.label' | translate
                }} </th>
                <td mat-cell *matCellDef="let element"> {{ getVariablesFromEssay(element) }} </td>
              </ng-container>
              <!-- Criteria Column -->
              <ng-container matColumnDef="criteria">
                <th mat-header-cell *matHeaderCellDef> {{ 'protocolEdit.essays.criteria.label' | translate
                }} </th>
                <td mat-cell *matCellDef="let element"> {{ getCriteriaFromEssay(element) }} </td>
              </ng-container>
              <!-- Load Column -->
              <ng-container matColumnDef="load">
                <th mat-header-cell *matHeaderCellDef> {{ 'protocolEdit.essays.load.label' | translate }}
                </th>
                <td mat-cell *matCellDef="let element"> {{ getLoadFromEssay(element) }} </td>
              </ng-container>
              <!-- Button see Column -->
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button mat-icon-button (click)="editEssayOpenDialog(i)">
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <!-- Button delete Column -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div matTooltip="{{ 'button.disabled.offline' | translate }}"
                    [matTooltipDisabled]="!disableOfflineButton">
                    <button mat-icon-button (click)="deleteEssayRow(i, element.uuid)"
                      [disabled]="disableOfflineButton && !showButton()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="essaysCols"></tr>
              <tr mat-row *matRowDef="let row; columns: essaysCols;" cdkDrag [cdkDragData]="row"></tr>
            </table>
          </div>
        }

        @if (isObjetiveEmpty() || isMetodologyEmpty() || isCriteriaEmpty()) {
          <div fxLayout="row" class="table-item title-table-test title-table-withpadding"
            >
            <div fxFlex="100">
              <div fxFlex="100" class="center-text">
                <span> {{ 'protocolEdit.test.dataGeneral.title' | translate }}</span>
              </div>
            </div>
          </div>
        }
        <div fxFlex="100" fxLayout="column" class="container-verification-data">
          <div fxFlex="100" fxLayout="column">
            @if (testConfig?.testGeneralData) {
              <div>
                @if (isObjetiveEmpty()) {
                  <div fxLayout="column">
                    <mat-accordion>
                      <mat-expansion-panel class="overflowX" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div fxFlex="100" class="table-item title-table-test-accordion">
                              <div fxFlex="100">
                                <div fxFlex="95" class="center-text">
                                  <span>{{'protocolEdit.test.objetive.title' |
                                  translate}}</span>
                                </div>
                                <div fxFlex="5">
                                  <button mat-icon-button (click)="refreshObjetive()"
                                    [disabled]="!showButton()"
                                    matTooltip="{{ 'button.refresh' | translate }}">
                                    <mat-icon>refresh</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (value of dataSource.protocolQTestGeneralData; track value; let indexTest = $index) {
                          <div fxLayout="row"
                            >
                            <div fxFlex="100" fxLayout="column">
                              <div fxFlex="100" class="table-item"
                                style="display: grid; margin-bottom: 50px">
                                <quill-editor #editor class="quill-container"
                                  [(ngModel)]="value.objective"
                                  (onTextChange)="onModelChange($event)"
                                  [name]="'objective' + indexTest" [id]="'objective' + indexTest"
                                  [modules]="quillConfig"
                                style="height: auto; font-weight: normal;"></quill-editor>
                              </div>
                            </div>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                }
                @if (isMetodologyEmpty()) {
                  <div fxLayout="column">
                    <mat-accordion>
                      <mat-expansion-panel class="overflowX" expanded="true">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <div fxFlex="100" class="table-item title-table-test-accordion">
                              <div fxFlex="100">
                                <div fxFlex="95" class="center-text">
                                  <span>{{'protocolEdit.test.methodology.title' |
                                  translate}}</span>
                                </div>
                                <div fxFlex="5">
                                  <button mat-icon-button (click)="refreshMethodology()"
                                    [disabled]="!showButton()"
                                    matTooltip="{{ 'button.refresh' | translate }}">
                                    <mat-icon>refresh</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (value of dataSource.protocolQTestGeneralData; track value; let indexTest = $index) {
                          <div fxLayout="row"
                            >
                            @if (value.methodology) {
                              <div fxFlex="100" fxLayout="column">
                                <div fxLayout="row" fxFlex="100" class="table-item"
                                  style="display: grid; margin-bottom: 50px">
                                  <quill-editor class="quill-container"
                                    [(ngModel)]="value.methodology"
                                    [name]="'methodology' + indexTest"
                                    [id]="'methodology' + indexTest" [modules]="quillConfig"
                                  style="height: auto; font-weight: normal;"></quill-editor>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                }
                @if (isCriteriaEmpty()) {
                  <div fxLayout="column">
                    @for (value of dataSource.protocolQTestGeneralData; track value; let indexTest = $index) {
                      <div fxLayout="row"
                        >
                        <mat-accordion>
                          <mat-expansion-panel class="overflowX" expanded="true">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <div fxFlex="100" class="table-item title-table-test-accordion">
                                  <div fxFlex="100">
                                    <div fxFlex="95" class="center-text">
                                      <span>{{'protocolTest.test.criteria' | translate
                                      }}</span>
                                    </div>
                                    <div fxFlex="5">
                                      <button mat-icon-button (click)="refreshCriteria()"
                                        [disabled]="!showButton()"
                                        matTooltip="{{ 'button.refresh' | translate }}">
                                        <mat-icon>refresh</mat-icon>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            @if (value.criteria) {
                              <div fxFlex="100" fxLayout="column">
                                <div fxLayout="row" fxFlex="100" class="table-item"
                                  style="display: grid; margin-bottom: 50px">
                                  <quill-editor class="quill-container" [(ngModel)]="value.criteria"
                                    [name]="'criteria' + indexTest" [id]="'criteria' + indexTest"
                                    [modules]="quillConfig"
                                  style="height: auto; font-weight: normal;"></quill-editor>
                                </div>
                              </div>
                            }
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>

        @if (testConfig?.probePlacement) {
          <div fxFlex="100" fxLayout="column">
            <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
              <div fxFlex="100">
                <div fxFlex="100" class="center-text">
                  <span> {{ 'protocolTest.test.location.probe' | translate }}</span>
                </div>
              </div>
            </div>
            <div fxFlex="100" fxLayout="column" class="container-verification-data">
              <div fxLayout="row" fxFlex="100" class="table-item" style="display: grid; margin-bottom: 50px">
                <quill-editor class="quill-container" [(ngModel)]="dataSource.imageTest"
                  [name]="'imageTest'" [id]="'imageTest'" [modules]="quillConfig"
                style="height: auto; font-weight: normal;"></quill-editor>
              </div>
            </div>
          </div>
        }

        @if (testConfig?.testVerification) {
          <div>
            <div fxLayout="column">
              <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
                <div fxFlex="100">
                  <div fxFlex="85" class="center-text">
                    <span style="margin-right: 5px;">{{'protocolTest.test.verification.test.tittle'
                      |
                    translate}}</span>
                  </div>
                  <div fxFlex="15">
                    <button class="btn-add" mat-raised-button (click)="newTestVerification()"
                      [disabled]="!showButton()">
                      {{ 'protocolTest.test.verification.new.btn' | translate }}
                      <mat-icon fxHide.lt-sm>add</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div fxLayout="column" class="container-verification-data">
                @for (value of dataSource.protocolQTestVerification; track value; let indexTest = $index) {
                  <div fxLayout="row"
                    >
                    <div fxFlex="35" class="table-item " class="input-dinamyc-item">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolTest.test.verification.test.item.test' | translate
                        }}</mat-label>
                        <input matInput [name]="'test' + indexTest" [(ngModel)]="value.test">
                      </mat-form-field>
                    </div>
                    <div fxFlex="30" class="table-item">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolTest.test.verification.test.item.description' |
                          translate
                        }}</mat-label>
                        <textarea matInput [name]="'descriptionTest' + indexTest"
                        [(ngModel)]="value.descriptionTest" rows="5"></textarea>
                      </mat-form-field>
                    </div>
                    <div fxFlex="30" class="table-item" class="input-dinamyc-item">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolTest.test.verification.test.item.result' | translate
                        }}</mat-label>
                        <mat-select multiple [name]="'vResultVerification'+indexTest"
                          [(ngModel)]="value.resultDesc">
                          @for (sel of resultQTypes; track sel) {
                            <mat-option checkboxPosition="before"
                              [value]="sel.translation">
                              {{'protocolTest.result.'+sel.translation | translate}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex="5">
                      <button class="btn-delete-verification" mat-icon-button
                        (click)="deleteTestVerification(indexTest)" [disabled]="!showButton()"
                        matTooltip="{{ 'button.delete' | translate }}">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        @if (dataSource.protocolQTestItemGroup) {
          <div fxFlex="100" fxLayout="column">
            <div fxLayout="row" class="table-item title-table-test title-table-withpadding">
              <div fxFlex="100">
                <div fxFlex="100" class="center-text">
                  <span>{{'protocolTest.test.verification.title' | translate }}</span>
                </div>
              </div>
            </div>
            <mat-tab-group  [selectedIndex]="_groupItem" (focusChange)="onEssayTabChange($event.index)">
              @for (group of dataSource.protocolQTestItemGroup; track group; let indexGroup = $index) {
                <mat-tab
                  style="min-height: 50vh;">
                  <ng-template mat-tab-label>
                    <span class="tab-text"> {{ group.translationType ? ('essayType.' +
                    group.translationType | translate) + ' ' : ''}} </span>
                    @if (group.title) {
                      <span class="tab-text" style="margin-left: 5px">{{ ' ('+
                      group.title +') '}}</span>
                    }
                    @if (displayCycle(group)) {
                      <span class="tab-text" style="margin-left: 5px"> {{
                      'testQualification.cicle' | translate }} {{group.numCycle}} </span>
                    }
                  </ng-template>
                  @if (group?.protocolQTestItems?.length > 0) {
                    <div>
                      <div fxLayout="column">
                        <div fxFlex="100" fxLayout="column" class="container-verification-data">
                          @for (item of group?.protocolQTestItems; track item; let indexItem = $index) {
                            <div fxFlex="100"
                              fxLayout="column">
                              <div fxFlex="100">
                                @if (testConfig.item) {
                                  <div fxFlex="15">
                                    <button class="btn-add" mat-raised-button
                                      (click)="newItemVeritication(indexGroup)"
                                      [disabled]="!showButton()">
                                      {{ 'Nuevo item' | translate }}
                                      <mat-icon fxHide.lt-sm>add</mat-icon>
                                    </button>
                                  </div>
                                }
                              </div>
                              <div fxFlex="100" fxLayout="row" class="table-item">
                                @if (testConfig?.item) {
                                  <div fxFlex="80">
                                    <mat-form-field class="campoFormulario">
                                      <mat-label>{{ 'Item' | translate }}</mat-label>
                                      <input matInput [name]="'item'+indexGroup+indexItem"
                                        [(ngModel)]="item.description">
                                    </mat-form-field>
                                  </div>
                                }
                                @if (testConfig?.item) {
                                  <div fxFlex="5">
                                    <button class="btn-delete-verification" mat-icon-button
                                      (click)="deleteRowItem(indexGroup, indexItem)"
                                      [disabled]="!showButton()"
                                      matTooltip="{{ 'button.delete' | translate }}">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </div>
                                }
                                <div fxFlex="20">
                                  <button class="btn-add" mat-raised-button [disabled]="!showButton()"
                                    (click)="newItemVerification(indexGroup, indexItem)">
                                    {{ 'Nueva verificación' | translate }}
                                    <mat-icon fxHide.lt-sm>add</mat-icon>
                                  </button>
                                </div>
                              </div>
                              <div cdkDropList [cdkDropListData]="item.protocolQTestItemVerification"
                                class="verification-drop-list"
                                (cdkDropListDropped)="drop($event, indexGroup, indexItem)">
                                @for (valueItemV of item.protocolQTestItemVerification; track trackByFn(indexItemV, valueItemV); let indexItemV = $index) {
                                  <div
                                    cdkDrag class="verification-drop-box" [cdkDragData]="valueItemV">
                                    <div fxFlex="100" fxLayout="column" class="table-item">
                                      <div fxFlex="100" fxLayout="row">
                                        <div fxFlex="85">
                                          <!-- Icono de arrastre (handler) -->
                                          <div fxFlex="5" cdkDragHandle>
                                            <span>
                                              <mat-icon
                                                [id]="'idOrder'+indexGroup+indexItem+indexItemV"
                                              class="move-drag-cursorr">reorder</mat-icon>
                                            </span>
                                          </div>
                                          <div fxFlex="95">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'protocolTest.test.item.verification.item'
                                                |
                                              translate }}</mat-label>
                                              <textarea matInput
                                                [name]="'verificationTypeDesc'+indexGroup+indexItem+indexItemV"
                                                [(ngModel)]="valueItemV.verification"
                                              rows="1"></textarea>
                                            </mat-form-field>
                                          </div>
                                        </div>
                                        <!--<div fxFlex="7">
                                        <button class="btn-add" mat-raised-button
                                          (click)="newDataVerification(indexGroup,indexItem,indexItemV)"
                                          [disabled]="!showButton()">
                                          <mat-icon fxHide.lt-sm>add</mat-icon>
                                        </button>
                                      </div>-->
                                      @if (valueItemV.id) {
                                        <div fxFlex="10">
                                          <button mat-raised-button [disabled]="!showButton()"
                                            (click)="openVisualizerImage(valueItemV)"
                                            class="stroked">
                                            <mat-icon
                                            fxHide.lt-sm>add_photo_alternate</mat-icon>
                                          </button>
                                        </div>
                                      }
                                      <div fxFlex="5">
                                        <button class="btn-delete-verification" mat-icon-button
                                          [disabled]="!showButton()"
                                          (click)="deleteRowItemVerification(indexGroup,indexItem,indexItemV)"
                                          matTooltip="{{ 'button.delete' | translate }}">
                                          <mat-icon fxHide.lt-sm>delete</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                    @for (value of valueItemV.protocolQTestDataMultiple; track value; let indexValue = $index) {
                                      <div
                                        >
                                        <div fxFlex="100" fxLayout="row" class="table-item">
                                          @if (testConfig?.expectedResult) {
                                            <div fxFlex="40" class="input-dinamyc-item"
                                              >
                                              <mat-form-field class="campoFormulario">
                                                @if (!value.expectedResultRhDesc) {
                                                  <mat-label
                                                    >{{
                                                    'protocolTest.test.result.expected.multiple.item'
                                                    |
                                                  translate }}</mat-label>
                                                }
                                                @if (value.expectedResultRhDesc) {
                                                  <mat-label>{{
                                                    value.expectedResultRhDesc
                                                  }}</mat-label>
                                                }
                                                <textarea matInput
                                                  [ngStyle]="{'background': !value.expectedResultDesc ? '#d5d5d5a3': 'transparent'}"
                                                  [name]="'expectedResultDesc'+indexGroup+indexItem+indexItemV+indexValue"
                                                  [(ngModel)]="value.expectedResultDesc"
                                                  cdkTextareaAutosize
                                                  #autosize="cdkTextareaAutosize"
                                                  cdkAutosizeMinRows="1"
                                                cdkAutosizeMaxRows="5"></textarea>
                                              </mat-form-field>
                                            </div>
                                          }
                                          <div fxFlex="10" fxLayout="column"
                                            class="input-dinamyc-item">
                                            <div fxFlex="100" style="font-weight: 100;">
                                              {{'protocolTest.test.result.expected.multiple.union'
                                              | translate }}
                                            </div>
                                            <div fxFlex="100">
                                              <mat-checkbox #tooltip="matTooltip"
                                                [name]="'changeOnlyLine'+indexGroup+indexItem+indexItemV+indexValue"
                                                [matTooltip]="'protocolTest.test.result.expected.multiple.item.tooltip' | translate"
                                                [(ngModel)]="value.onlyLine"
                                                (change)="onChangeOnlyLine($event,indexGroup,indexItem,indexItemV,indexValue)">
                                              </mat-checkbox>
                                            </div>
                                          </div>
                                          <div fxFlex="40" class="input-dinamyc-item">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'protocolTest.test.multiple.result.item'
                                                |
                                              translate }}</mat-label>
                                              <mat-select multiple
                                                [name]="'sResultDesc'+indexGroup+indexItem+indexItemV+indexValue"
                                                [(ngModel)]="value.resultDesc">
                                                @for (sel of resultQTypes; track sel) {
                                                  <mat-option
                                                    checkboxPosition="before"
                                                    [value]="sel.translation">
                                                    {{'protocolTest.result.'+sel.translation
                                                    |
                                                    translate}}
                                                  </mat-option>
                                                }
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                          @if (value.id && !value.onlyLine) {
                                            <div fxFlex="10">
                                              <button mat-raised-button [disabled]="!showButton()"
                                                (click)="openVisualizerImageMultiple(value)"
                                                class="stroked">
                                                <mat-icon
                                                fxHide.lt-sm>add_photo_alternate</mat-icon>
                                              </button>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
    </div>

    <!--<div fxFlex *ngIf="data.data.id">
    <app-protocol-q-edit-test-attachments #attachmentsTestComponent [idTest]="data.data.id"
      [idProtocol]="data.data.idProtocol" [idStatus]="data.idStatus">
    </app-protocol-q-edit-test-attachments>
  </div>-->


  <div mat-dialog-actions class="qualificates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" [disabled]="!showButton()">{{
    'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate
    }}</button>
  </div>

</div>
</div>
</form>